import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tipsButtonLabel: {
		id: 'business-summary.summary-view.types-of-work.add-issue-types.issue-types-hierarchy-education-button.tips-button-label',
		defaultMessage: 'What are issue types?',
		description: 'Label for button that opens the issue types hierarchy education modal.',
	},
});
